import React, { useState, useEffect, useCallback } from "react";
import useDownloader from 'react-use-downloader'
import Header from '../components/Header'
import Footer from '../components/Footer'
import axios from "axios";
import usePageSEO from '../hooks/usePageSEO'
import Loader from '../components/Loader'

const DownloadCertificates = () => {
    const [loading, setLoading] = useState(true);    
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const siteUrl = process.env.REACT_APP_BACKEND_URL;
    const { size, elapsed, percentage, download, cancel, error, isInProgress } = useDownloader(); 
    
    const [data, setData] = useState('')
    const [widgetdata, setWidgetdata] = useState('')
    const [metaTitle, setMetaTitle] = useState('');
    const [metaDescription, setMetaDescription] = useState('');
    const [certificatedata, setCertificateData] = useState([])
    const apiUrl = apiBaseUrl+`downloadpage`;   

  const fetchInfo = useCallback(() => {
    return axios.get(apiUrl).then((res) => {
      setData(res.data.page)
      setMetaTitle(res.data.page.meta_title);
      setMetaDescription(res.data.page.meta_description); 
      setWidgetdata(res.data.certificatewidget);
      setCertificateData(res.data.certificate);  
    });
  },[]);

  useEffect(() => {
    setTimeout(() => {
      fetchInfo()
        setLoading(false);
    }, 2000);
  }, [fetchInfo]);

  usePageSEO({
    title: `${metaTitle}`,
    description: `${metaDescription}`
  }) 

  const handleDownload = (url) => {
    //alert(url);
    //alert(fileName);
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.download = "downloaded-file";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
    .catch((error) => {
        console.error("Error fetching the file:", error);
    });
  };


    return (
        <>
        <Header/>
        { loading && (<Loader /> )}
        <section className="section-content-block">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                            <div className="about-us-intro">
                                <p className="blue">{data?.name}</p>
                                <h2 className="heading">{data?.page_heading}</h2>
                                <p>{data?.short_description}</p>
                            </div>                            
                        </div> 
                        
                    </div>
                </div> 
        </section>
            
        <div className="container"><hr /></div>
            
        <section className="section-content-block">
            <div className="container">
                <div className="row pb-100">
                    <div className="col-lg-12 col-md-12 col-sm-12 ">                       
                        <div className="about-us-intro">
                            <p className="our-experience">{widgetdata?.heading}</p>
                            <p>{widgetdata?.description}</p>
                        </div>                            
                    </div> 

                {certificatedata.map((item, index) => {
                    return (
                    <div className="col-lg-4 col-md-4 col-sm-12 text-center" key={index}>                       
                        <div 
                            className="Products download-wrapper position-relative"
                              onClick={() => download(`${item.pdf_file}`, `${item.name}.pdf`)}
                            >
                            <img src={item.image} alt={item.name} />
                            <span className="download-icon position-absolute"><i className="fa fa-download"></i></span>
                            <h4 className="heading">{item.name}</h4>
                        </div>                            
                    </div>
                    )
                })}

                    
                </div>
                
                <div className="container"><hr /></div>

            </div> 

        </section>

        <Footer/>
        </>
    
      )
}

export default DownloadCertificates